export class CustomerDto {
  id: string;
  createdBy: string;
  creationDate: Date;
  modifiedBy: string;
  modificationDate: Date;
  code: string;
  label: string;
  address: string;
  address1: string;
  address2: string;
  number: string;
  postcode: string;
  country: string;
  commercialRegion: string;
  logo: string;
  geographicalAreas: string;
  state: boolean;
}